export default "__VITE_ASSET__CK3p2gcu__"